@use "variables" as *;

.dialog {
  display: flex;
  flex-direction: column;
}

.subtitle {
  text-align: center;
  font-weight: bold;
  font-size: $fontSize-m;
}

.message {
  text-align: center;
  font-weight: normal;
  font-size: $fontSize-s;
  white-space: pre-wrap;
}

.foldersCard {
  margin-bottom: $spacing-m !important;
}

.checkbox {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.checkboxHelpText {
  font-size: $fontSize-s;
  font-weight: normal;
}
